import { Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { BackButton, TranslatePipe } from '@cmi/addin-core';
import { map } from 'rxjs';
import { Breadcrumb } from '../../../shared/breadcrumb/breadcrumb';
import { ParameterValueEditor } from '../../../shared/parameter-value-editor/parameter-value-editor';
import { HomeService } from '../../home.service';

@Component({
  selector: 'cmi-parameter-settings',
  imports: [BackButton, TranslatePipe, Breadcrumb, ParameterValueEditor],
  templateUrl: './parameter-settings.html'
})
export class ParameterSettings {
  private readonly _route = inject(ActivatedRoute);
  private readonly _homeService = inject(HomeService);

  public readonly tag: Signal<string> = toSignal(
    this._route.paramMap.pipe(map((params) => params.get('tag') ?? '')),
    { initialValue: '' }
  );
  public readonly key: Signal<string> = toSignal(
    this._route.paramMap.pipe(map((params) => params.get('key') ?? '')),
    { initialValue: '' }
  );
  public readonly parameterName: Signal<string> = toSignal(
    this._route.paramMap.pipe(map((params) => params.get('parameterName') ?? '')),
    { initialValue: '' }
  );

  public readonly contentProvider = computed(() =>
    this._homeService.getContentProviderSignal(this.tag(), this.key())
  );
  public readonly providerParameter = computed(() =>
    this._homeService.getContentProviderParameter(this.tag(), this.key(), this.parameterName())
  );
  public readonly parameterType = computed((): 'text' | 'date' | 'number' | 'boolean' => {
    const typeName = this.providerParameter()?.typeName ?? '';
    if (typeName === 'DateTime') {
      return 'date';
    }
    if (typeName === 'Boolean') {
      return 'boolean';
    }
    if (typeName === 'Number' || typeName === 'Double' || typeName === 'Int') {
      return 'number';
    }
    return 'text';
  });
}
